$bog_lk_avatar $mol_button_open
	entity null
